import { calculateConvertedAmount } from '@features/paymentReconciliationModal/utils'

import { BookkeepingItem } from '../types/bookkeepingItem'

export const getItemAmountInAccountCurrency = (item: BookkeepingItem, accountCurrency?: string): number => {
  const isCrossCurrency = item.currency && item.currency !== accountCurrency
  return isCrossCurrency && item.exchangeRate ? calculateConvertedAmount(item.exchangeRate, item.amount) : item.amount
}
